/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvoiceLineItemSchema } from './InvoiceLineItemSchema';
import {
    InvoiceLineItemSchemaFromJSON,
    InvoiceLineItemSchemaFromJSONTyped,
    InvoiceLineItemSchemaToJSON,
} from './InvoiceLineItemSchema';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
} from './InvoiceStatus';
import type { PaymentMethodSchema } from './PaymentMethodSchema';
import {
    PaymentMethodSchemaFromJSON,
    PaymentMethodSchemaFromJSONTyped,
    PaymentMethodSchemaToJSON,
} from './PaymentMethodSchema';

/**
 * 
 * @export
 * @interface InvoiceSchema
 */
export interface InvoiceSchema {
    /**
     * 
     * @type {number}
     * @memberof InvoiceSchema
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSchema
     */
    stripeId?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceSchema
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceSchema
     */
    amountCents?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSchema
     */
    date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSchema
     */
    dueDate?: Date;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof InvoiceSchema
     */
    status?: InvoiceStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSchema
     */
    attempted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSchema
     */
    paid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSchema
     */
    invoicePdf?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSchema
     */
    billingReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSchema
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSchema
     */
    customer?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceSchema
     */
    organizationId?: number;
    /**
     * 
     * @type {Array<InvoiceLineItemSchema>}
     * @memberof InvoiceSchema
     */
    lineItems: Array<InvoiceLineItemSchema>;
    /**
     * 
     * @type {PaymentMethodSchema}
     * @memberof InvoiceSchema
     */
    paymentMethod?: PaymentMethodSchema;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSchema
     */
    link?: string;
}

/**
 * Check if a given object implements the InvoiceSchema interface.
 */
export function instanceOfInvoiceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "lineItems" in value;

    return isInstance;
}

export function InvoiceSchemaFromJSON(json: any): InvoiceSchema {
    return InvoiceSchemaFromJSONTyped(json, false);
}

export function InvoiceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'stripeId': !exists(json, 'stripe_id') ? undefined : json['stripe_id'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'amountCents': !exists(json, 'amount_cents') ? undefined : json['amount_cents'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'dueDate': !exists(json, 'due_date') ? undefined : (new Date(json['due_date'])),
        'status': !exists(json, 'status') ? undefined : InvoiceStatusFromJSON(json['status']),
        'attempted': !exists(json, 'attempted') ? undefined : json['attempted'],
        'paid': !exists(json, 'paid') ? undefined : json['paid'],
        'invoicePdf': !exists(json, 'invoice_pdf') ? undefined : json['invoice_pdf'],
        'billingReason': !exists(json, 'billing_reason') ? undefined : json['billing_reason'],
        'created': (new Date(json['created'])),
        'customer': !exists(json, 'customer') ? undefined : json['customer'],
        'organizationId': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'lineItems': ((json['line_items'] as Array<any>).map(InvoiceLineItemSchemaFromJSON)),
        'paymentMethod': !exists(json, 'payment_method') ? undefined : PaymentMethodSchemaFromJSON(json['payment_method']),
        'link': !exists(json, 'link') ? undefined : json['link'],
    };
}

export function InvoiceSchemaToJSON(value?: InvoiceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stripe_id': value.stripeId,
        'amount': value.amount,
        'amount_cents': value.amountCents,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'due_date': value.dueDate === undefined ? undefined : (value.dueDate.toISOString()),
        'status': InvoiceStatusToJSON(value.status),
        'attempted': value.attempted,
        'paid': value.paid,
        'invoice_pdf': value.invoicePdf,
        'billing_reason': value.billingReason,
        'created': (value.created.toISOString()),
        'customer': value.customer,
        'organization_id': value.organizationId,
        'line_items': ((value.lineItems as Array<any>).map(InvoiceLineItemSchemaToJSON)),
        'payment_method': PaymentMethodSchemaToJSON(value.paymentMethod),
        'link': value.link,
    };
}

